export { default } from './RecordingFileSection';
